import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <footer className="site-footer">
        <div className="container footer-grid">
          <div className="footer-brand">
            <a href="#top" className="brand">
              <img
                src="/assets/website/images/logo.svg"
                alt="RouteRider logo"
                className="brand-logo"
              />
              <span className="brand-name light">
                Route<span className="accent-text">Rider</span>
              </span>
            </a>
            <p>
              Intercity cab &amp; seat sharing — fixed routes, fixed fares,
              verified rides.
            </p>
            <div className="social-row">
              <a href="#" aria-label="Facebook">
                f
              </a>
              <a href="#" aria-label="Instagram">
                ◎
              </a>
              <a href="#" aria-label="X / Twitter">
                𝕏
              </a>
              <a href="#" aria-label="LinkedIn">
                in
              </a>
            </div>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <a href="#">About us</a>
            <a href="#">Careers</a>
            <a href="#">Blog</a>
            <a href="#">Press</a>
          </div>
          <div className="footer-col">
            <h4>Support</h4>
            <a href="#faq">Help centre</a>
            <a href="#safety">Trust &amp; safety</a>
            <a href="#">Contact us</a>
            <a href="#">Cancellation policy</a>
          </div>
          <div className="footer-col" id="fleetOwnerPartners">
            <h4>For partners</h4>
            <Link to="/login_fleetowner">Fleet Owner log in</Link>
            <Link to="/signup_fleetowner">Fleet Owner sign up</Link>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <a href="#">Terms of service</a>
            <a href="#">Privacy policy</a>
            <a href="#">Refund policy</a>
          </div>
          <div className="footer-col newsletter">
            <h4>Stay updated</h4>
            <form id="newsletterForm">
              <input type="email" placeholder="Your email" required="" />
              <button type="submit" className="btn btn-primary btn-sm">
                Subscribe
              </button>
            </form>
            <p className="newsletter-msg" id="newsletterMsg" />
          </div>
        </div>
        <div className="container footer-bottom">
          <p>
            © <span id="year">2026</span> RouteRider. All rights reserved.
          </p>
          <p>Made for riders, by riders.</p>
        </div>
      </footer>
    </>
  );
}
